import { useContext, createContext } from "react"
import { SelectProps } from "./types"
import { useSelect } from "./useSelect"

type UseSelectReturnValue = ReturnType<typeof useSelect>

export const SelectContext = createContext<
  Partial<UseSelectReturnValue & SelectProps & { isSM: boolean; isMD: boolean }>
>({})

export const useSelectContext = () => useContext(SelectContext)
